"use strict";

var isCallable = require("./object/is-callable");

module.exports = function (value) {
	try {
		if (value && isCallable(value.toString)) return value.toString();
		return String(value);
	} catch (e) {
		return "<Non-coercible to string value>";
	}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/safe-to-string.js
// module id = 2941
// module chunks = 0